import { useState } from 'react';

import { SignInForm } from '@/shared/components/account/signForms/SignInForm';
import { RemindPassword } from '@/shared/components/account/signForms/RemindPassword';
import { ChangePassword } from '@/shared/components/account/signForms/ChangePassword';

import styles from './accountConfirmationModal.module.scss';
import { AccountConfirmationModalProps } from './types';
import { SignUpReasons } from '@/shared/components/account/authModal/components/SignUpReasons';

export const AccountConfirmationModal = ({
	accountConfirmation,
	handleModalClose,
	setAccountConfirmation,
}: AccountConfirmationModalProps) => {
	const [remindPasswordActive, setRemindPasswordActive] = useState(false);
	const [changePasswordActive, setChangePasswordActive] = useState<string | null>(null);

	const backToLoginPress = () => {
		setRemindPasswordActive(false);
	};

	const remindPasswordClickCallback = () => {
		setAccountConfirmation(false);
	};

	return (
		<div className={styles.authModal__container}>
			<SignUpReasons />
			<div className={styles.accountConfirmationModal__wrapper}>
				{remindPasswordActive ? (
					<RemindPassword backToLoginPress={backToLoginPress} />
				) : changePasswordActive ? (
					<ChangePassword
						changePasswordActive={changePasswordActive}
						setChangePasswordActive={setChangePasswordActive}
					/>
				) : (
					<SignInForm
						accountConfirmation={accountConfirmation}
						setChangePasswordActive={setChangePasswordActive}
						setRemindPasswordActive={setRemindPasswordActive}
						handleModalClose={handleModalClose}
						remindPasswordClickCallback={remindPasswordClickCallback}
					/>
				)}
			</div>
		</div>
	);
};
